import React, {Component} from 'react'

var Loader                  = require('react-loader');
var _                       = require('lodash');
var ExperienceStoreJson     = require('../../build/contracts/ExperienceStore.json');
var ExperienceStoreAddr     = ExperienceStoreJson.networks["4"].address;

// let MAX_RESULTS = 10;

class ShowQueryByRecruiter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      credentials: {},
      loadingCredentials: false,
      addresses: []
    };
    this.props.web3.eth.getTransactionReceiptMined     = require('./transactionReceipt')
  }

  componentWillMount() {
  }


  async queryExperience() {
    this.setState({loadingCredentials: true, addresses: []});
    try {
      let addresses       = [];
      let This            = this;
      let experience      = Number(this.state.credentials.experience);
      console.log(this.state.credentials.experience)
      let skill           = this.state.credentials.skill.trim();
      let Props           = this.props;
      let sender          = this.props.web3.eth.accounts[0];
      console.log(sender)

      this.props.experienceStoreContractInstance.amountOfTokensForQuerying({gas: 500000,gasPrice: 1200000000}).then((tokens)=>{
        let tokenRequired   = tokens/1000000000000000000;
          this.props.echoLinkContractInstance.allowance(sender,ExperienceStoreAddr,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
          console.log(result/1000000000000000000);
          let availableTokens   = result/1000000000000000000;
          if(availableTokens >= tokenRequired){
            Props.experienceStoreContractInstance.queryExperiences(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
              Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({loadingCredentials: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("query experience successfully");
                    Props.experienceStoreContractInstance.getExperienceResultWhenTrue(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                    if(addressesArray.length !== 0){
                      Props.experienceStoreContractInstance.setExperienceToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                        Props.web3.eth.getTransactionReceiptMined(setFalse.tx,10,function(txHash){
                          if(txHash.txStatus === 0){
                            This.setState({loadingCredentials: false});
                            Props.addNotification(`Transaction Exection Failed!`,"error");
                          }
                          if(txHash.txStatus === 1){
                            console.log("Address set to false");
                             addresses.push(addressesArray);
                             This.setState({loadingCredentials: false, addresses: addresses});
                          }
                        })
                      })
                    }
                    else{
                      console.log("blank array");
                      addresses.push(0);
                      This.setState({loadingCredentials: false, addresses: addresses});
                    }
                  })
                }
              })
            })
          }
          else if(availableTokens === 0){
            Props.echoLinkContractInstance.approve(ExperienceStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({loadingCredentials: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("approved successfully");
                  Props.experienceStoreContractInstance.queryExperiences(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                    Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({loadingCredentials: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("query experience successfully");
                        Props.experienceStoreContractInstance.getExperienceResultWhenTrue(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                          console.log("array: ",addressesArray)
                          if(addressesArray[0].length !== 0){
                            Props.experienceStoreContractInstance.setExperienceToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                              Props.web3.eth.getTransactionReceiptMined(setFalse.tx,10,function(txHash){
                                if(txHash.txStatus === 0){
                                  This.setState({loadingCredentials: false});
                                  Props.addNotification(`Transaction Exection Failed!`,"error");
                                }
                                if(txHash.txStatus === 1){
                                  console.log("Address set to false");
                                    addresses.push(addressesArray);
                                     This.setState({loadingCredentials: false, addresses: addresses});
                                }
                              })
                            })
                          }
                          else{
                            console.log("blank array");
                            addresses.push(0);
                            This.setState({loadingCredentials: false, addresses: addresses});
                          }
                        })
                      }
                    })
                  })
                }
              })
            })
          }
          else{
            Props.echoLinkContractInstance.approve(ExperienceStoreAddr,0,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({loadingCredentials: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("first Approve success");
                  Props.echoLinkContractInstance.approve(ExperienceStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((results)=>{
                    Props.web3.eth.getTransactionReceiptMined(results.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({loadingCredentials: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("approved successfully");
                        Props.experienceStoreContractInstance.queryExperiences(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                          Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                            if(txHash.txStatus === 0){
                              This.setState({loadingCredentials: false});
                              Props.addNotification(`Transaction Exection Failed!`,"error");
                            }
                            if(txHash.txStatus === 1){
                              console.log("query experience successfully");
                              Props.experienceStoreContractInstance.getExperienceResultWhenTrue(skill,experience,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                                if(addressesArray.length !== 0){
                                  Props.experienceStoreContractInstance.setExperienceToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                                    Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                                      if(txHash.txStatus === 0){
                                        This.setState({loadingCredentials: false});
                                        Props.addNotification(`Transaction Exection Failed!`,"error");
                                      }
                                      if(txHash.txStatus === 1){
                                        console.log("Address set to false");
                                          addresses.push(addressesArray);
                                           This.setState({loadingCredentials: false, addresses: addresses});
                                      }
                                    })
                                  })
                                }
                                else{
                                    console.log("blank array");
                                    addresses.push(0);
                                    This.setState({loadingCredentials: false, addresses: addresses});
                                  }
                              })
                            }
                          })
                        })
                      }
                    })
                  })
                }
              })
            })

          }
      })
      })
    }
    catch (err) {
      this.setState({loadingCredentials: false});
      this.props.addNotification(err.message, "error");
    }
  }

  validForm() {
    if (!this.props.experienceStoreContractInstance) {
      return false;
    }

    let credential = this.state.credentials;
    return credential.experience &&
      credential.skill && credential.skill.trim();
  }

  updateInputValue(e, field) {
    let credential = this.state.credentials;
    credential[field] = e.target.value;
    this.setState({credential});
  }

  obfuscate(hash) {
    return hash.substring(0, 5) + "**********" + hash.substring(hash.length - 5, hash.length);
  }
  
  RecruiterFetch(){
    var recruiters      = [];
    var recruiterAddr   = this.state.addresses[0];
    for(var i=0;i<recruiterAddr[0].length;i++){
      recruiters.push(<tr className="pure-u-24-24"><td className="pure-u-11-24 tdStyle">{recruiterAddr[0][i]}</td><td className="pure-u-11-24 tdStyle">{recruiterAddr[1][i]}</td></tr>);
    }
    return recruiters;
  }

  renderCredential(Addresses){
    console.log("render: ",Addresses)
    if(Addresses === 0){
      return(<div><h3>no Match Found</h3></div>);
    }
    return(
      <table className="pure-u-24-24">
        <thead className="pure-u-24-24">
          <tr className="pure-u-24-24">
              <th className="pure-u-11-24 thStyle">Recruiter Address</th>
              <th className="pure-u-11-24 thStyle">Employee Address</th>
          </tr>
        </thead>
        <tbody className="pure-u-24-24">
          {this.RecruiterFetch()}
        </tbody>
      </table>
         
    );
  }

  render() {
    return (
      <div className="ShowQueryByRecruiter">
        <div className="pure-u-24-24"></div>
        <form className="pure-form" onSubmit={(e) => event.preventDefault()}>
          <fieldset className="pure-group">
            <div className="pure-u-4-24">
              <span><b>Employee Experience: </b></span>
            </div>
            <div className="pure-u-4-24">
              <input type="number" className="pure-input-1-16" placeholder="Years"
                     value={this.state.credentials.experience} onChange={e => this.updateInputValue(e, 'experience')}/>
            </div>
            <div className="pure-u-24-24"></div>
            <div className="pure-u-4-24">
              <span><b>Experience in: </b></span>
            </div>
            <div className="pure-u-16-24">
              <input type="text" className="pure-input-1-2" placeholder="Skill : Java,MySql,etc."
                     value={this.state.credentials.skill} onChange={e => this.updateInputValue(e, 'skill')}/>
            </div>
          </fieldset>

          <Loader loaded={!this.state.loadingCredentials}>
            <div className="pure-u-4-24"></div>
            <button type="button" className="pure-button pure-input-1-3 button-success"
                    disabled={!this.validForm() || this.state.loadingCredentials}
                    onClick={() => this.queryExperience()}>Load
            </button>
          </Loader>
        </form>
        <div className="pure-u-24-24"></div>
        <div>
          {this.state.addresses.map((Address) => this.renderCredential(Address))}
        </div>
      </div>
    );
  }
}

export default ShowQueryByRecruiter;



// WEBPACK FOOTER //
// ./src/components/ShowQueryByRecruiter.js